const findNewlyAddedOrIncreasedItem = (cartBeforeAdd, cartAfterAdd) => {
  for (const currentItem of cartAfterAdd.items) {
    const previousItem = cartBeforeAdd.items?.find(p => p.variant_id === currentItem.variant_id);
    if (!previousItem) {
      return { item: currentItem, addedQuantity: currentItem.quantity };
    } else if (currentItem.quantity > previousItem.quantity) {
      return { item: currentItem, addedQuantity: currentItem.quantity - previousItem.quantity };
    }
  }
  return null;
};

const isNotBuyableCard = (productCard) => {
  try {
    const raw = JSON.parse(productCard.dataset.product || '{}').tags;
    const tags = Array.isArray(raw) ? raw : (typeof raw === 'string' ? raw.split(',') : null);
    if (!tags) return false;
    return tags.some(tag => String(tag).toLowerCase().trim() === 'not-buyable');
  } catch (error) {
    return false;
  }
};

const initBoostAddToCartTracking = (attempts = 0) => {
  const maxAttempts = 25;
  const boostAddToCartButtons = document.querySelectorAll('.boost-sd__button--select-option');

  if (boostAddToCartButtons.length === 0) {
    if (attempts < maxAttempts) {
      setTimeout(() => initBoostAddToCartTracking(attempts + 1), 200);
    }
    return;
  }

  boostAddToCartButtons.forEach(button => {
    if (button.dataset.gtmBoostAtcAttached === 'true') return;

    button.addEventListener('click', async function() {
      const productCard = button.closest('.boost-sd__product-item');
      if (!productCard) return;

      const productId = productCard.dataset.productId;
      if (!productId) {
        console.error('Product ID not found for Boost add to cart');
        return;
      }

      // Not-buyable products are removed from the cart again on the next
      // render, so reporting the add would inflate add_to_cart.
      if (isNotBuyableCard(productCard)) return;

      let cartBeforeAdd;
      try {
        const response = await fetch('/cart.js');
        cartBeforeAdd = await response.json();
      } catch (error) {
        cartBeforeAdd = { items: [] };
      }

      setTimeout(async () => {
        try {
          const response = await fetch('/cart.js');
          const cartAfterAdd = await response.json();

          const addedItem = findNewlyAddedOrIncreasedItem(cartBeforeAdd, cartAfterAdd);

          const populateGtmConfig = (variantId) => {
            if (productCard.dataset.gtmItem && !window.gtmConfig?.items?.[variantId]) {
              try {
                const gtmItem = JSON.parse(productCard.dataset.gtmItem);
                // Omit price/tax — data-gtm-item has first-variant price which may
                // differ from the actual added variant. Let buildGtmItem use the
                // correct price from the cart response instead.
                const { price, tax, ...gtmItemWithoutPrice } = gtmItem;
                window.gtmConfig = window.gtmConfig || {};
                window.gtmConfig.items = window.gtmConfig.items || {};
                window.gtmConfig.items[variantId] = gtmItemWithoutPrice;
              } catch (e) {
                // Ignore parse errors, trackCartAction will use cart data fallback
              }
            }
          };

          if (addedItem) {
            populateGtmConfig(addedItem.item.variant_id);
            trackCartAction('add_to_cart', cartAfterAdd, addedItem.item.variant_id, addedItem.addedQuantity);
            console.info('✓ Tracked Boost add to cart for variant:', addedItem.item.variant_id);
          } else {
            const itemMatchedByProductId = cartAfterAdd.items.find(item => item.product_id === parseInt(productId));
            if (itemMatchedByProductId) {
              populateGtmConfig(itemMatchedByProductId.variant_id);
              trackCartAction('add_to_cart', cartAfterAdd, itemMatchedByProductId.variant_id, 1);
              console.info('✓ Tracked Boost add to cart for variant (fallback):', itemMatchedByProductId.variant_id);
            } else {
              console.warn('Could not find added item in cart for product:', productId);
            }
          }
        } catch (error) {
          console.error('Error tracking Boost add to cart:', error);
        }
      }, 500);
    });

    button.dataset.gtmBoostAtcAttached = 'true';
  });
};

window.onGtmReady(function() {
  initBoostAddToCartTracking();
});
